module.exports = __webpack_public_path__ + "5a3dbd2c47.ttf";